<flx-modal
  [dismissible]="true"
  (dismiss)="close()"
  class="flx-ds"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ modalTitle }}
  </div>

  @if (exportedVersion?.branchName) {
    <div
      class="flex items-center justify-center flex-wrap gap-1.5"
      flxModalHeaderSubtitle
    >
      <flx-branch-state-icon
        [status]="exportedVersion.status"
        [branchName]="exportedVersion.branchName"
        [customClasses]="'flex h-4 w-4'"
        [branchOrder]="exportedVersion.branchOrder"
      />
      <flx-branch-name
        [branchName]="exportedVersion.branchName"
        [branchOrder]="exportedVersion.branchOrder"
      />
      @if (exportedVersion.status) {
        <flx-branch-state [status]="exportedVersion.status" />
      }
    </div>
  } @else if (exportedBuild?.buildTag) {
    <flx-build-tag
      [buildTagVersion]="exportedBuild.buildTag"
      [appName]="exportedBuild.appName"
      flxModalHeaderSubtitle
      size="xs"
    />
  }

  <div class="flx-modal-body">
    <flx-idea-helper-box>
      {{ infoText }}
    </flx-idea-helper-box>

    <div
      [formGroup]="exportFG"
      (submitForm)="submitModal()"
      class="flex flex-col gap-4 -mt-4"
      flxEnterSubmitForm
    >
      @if (hasTargetPlatformVersion) {
        @if (targetPlatformOptions.isLoading()) {
          <div class="flex justify-center py-2">
            <flx-spinner size="small" />
          </div>
        } @else if (noTargetPlatformOptions()) {
          <flx-error data-testId="platform-version-unavailable">
            No target platform version is available. Export is disabled until the list can be
            loaded.
          </flx-error>
        } @else {
          <flx-select
            class="flx-ds"
            formControlName="flowxVersion"
            data-testId="platform-version-dropdown"
          >
            <flx-label class="flx-ds">Target platform version</flx-label>
            @for (option of exportTargetPlatformOptions(); track $index) {
              <flx-select-option
                [value]="option.value"
                [attr.data-testId]="'version-option-' + option.value"
                class="flx-ds"
              >
                {{ option.label }}
              </flx-select-option>
            }
            <flx-helper>Select the platform version running in the target environment.</flx-helper>
            @if (isCurrentVersionSelected()) {
              <p
                class="text-neutral-500"
                flxSuffix
              >
                Current Version
              </p>
            }
          </flx-select>
        }
      }

      <flx-switch
        class="flx-ds"
        formControlName="includeBinaries"
        labelPosition="end"
      >
        <flx-label class="flx-ds">Include media file content</flx-label>
        <flx-info-helper>
          Including media file content may increase export and import time.
        </flx-info-helper>
      </flx-switch>
    </div>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="close()"
        class="flx-ds secondary"
        data-testId="cancel-button"
        flxButton
        type="button"
        variant="ghost"
      >
        Cancel
      </button>
      <button
        [disabled]="noTargetPlatformOptions()"
        (click)="submitModal()"
        class="flx-ds primary"
        data-testId="submit-export-type"
        flxButton
        type="button"
      >
        {{ isDownloadAvailable() ? 'Download' : 'Export' }}
      </button>
    </div>
  </div>
</flx-modal>
